import React from 'react';

import './index.css';
import ButtonGroup from './buttonGroupFormElement';
import ButtonMultiple from './buttonMultiple';
import TextFormElement from './textFormElement';
import TextHeadingSubheading from './textHeadingSubheading';
import DropdownFormElement from './dropdownFormElement';
import InfoFormElement from './infoFormElement';
import NumberFormElement from './numberFormElement';
import TextAreaFormElement from './textAreaFormElement';
import MultiAiTextArea from './multiAiTextArea';
import DatePicker from './datePicker';
import RadioInputs from './radioInputs';
import ShouldAiGenerate from './shouldAiGenerate';
import Wrapper from './wrapper';
import SurveySummary from './surveySummary';
import DropdownAutocomplete from './dropdownAutocomplete';
import ClientsDropdownAutocomplete from './clientsDropdownAutocomplete';
import SurveyRangeSlider from './surveyRangeSlider';
import SurveyPositiveRangeSlider from './surveyPositiveRangeSlider';
import SurveyRangeSliderLeft from './surveyRangeSliderLeft';
import SurveyRangeSliderOnlyPositive from './surveyRangeSliderOnlyPositive';

const SurveyInputs = props => {
  const question = props.question || props.questions[props.activeQuestion];

  switch (question.type) {
    case 'button':
      return (
        <ButtonGroup
          id={question.id}
          name={props.name}
          value={props.surveyAnswersState[question.id]}
          text={question.text}
          options={question.options}
          handleSurveyAnswers={props.handleSurveyAnswers}
          isInGroup={props.isInGroup}
          isSummary={props.isSummary}
        />
      );
    case 'button-multiple':
      return (
        <ButtonMultiple
          id={question.id}
          dependancySelection={question.dependancySelection}
          value={props.surveyAnswersState}
          text={question.text}
          options={question.options}
          handleSurveyAnswers={props.handleSurveyAnswers}
          isInGroup={props.isInGroup}
          isSummary={props.isSummary}
        />
      );
    case 'text':
      return (
        <TextFormElement
          id={question.id}
          name={props.name}
          value={props.surveyAnswersState[question.id]}
          text={question.text}
          handleSurveyAnswers={props.handleSurveyAnswers}
          isInGroup={props.isInGroup}
          isSummary={props.isSummary}
          isDependent={props.isDependent}
        />
      );
    case 'text-heading-subHeading':
      return (
        <TextHeadingSubheading
          id={question.id}
          value={props.surveyAnswersState[question.id]}
          heading={question.heading}
          subHeading={question.subHeading}
          handleSurveyAnswers={props.handleSurveyAnswers}
          isInGroup={props.isInGroup}
          isSummary={props.isSummary}
        />
      );
    case 'text-area':
      return (
        <TextAreaFormElement
          id={question.id}
          name={props.name}
          value={props.surveyAnswersState[question.id]}
          text={question.text}
          handleSurveyAnswers={props.handleSurveyAnswers}
          isInGroup={props.isInGroup}
          isSummary={props.isSummary}
        />
      );
    case 'multi-ai-text-area':
      return (
        <MultiAiTextArea
          value={props.surveyAnswersState[question.id]}
          surveyAnswersState={props.surveyAnswersState}
          textAreas={question.textAreas}
          id={question.id}
          handleSurveyAnswers={props.handleSurveyAnswers}
        />
      );
    case 'date-picker':
      return (
        <DatePicker
          id={question.id}
          value={props.surveyAnswersState[question.id]}
          isInGroup={props.isInGroup}
          isSummary={props.isSummary}
          text={question.text}
          handleSurveyAnswers={props.handleSurveyAnswers}
        />
      );
    case 'radio':
      return (
        <RadioInputs
          id={question.id}
          value={props.surveyAnswersState[question.id]}
          isInGroup={props.isInGroup}
          isSummary={props.isSummary}
          text={question.text}
          handleSurveyAnswers={props.handleSurveyAnswers}
          options={question.options}
        />
      );
    case 'should-ai-generate':
      return (
        <ShouldAiGenerate
          id={question.id}
          value={props.surveyAnswersState[question.id]}
          text={question.text}
          handleSurveyAnswers={props.handleSurveyAnswers}
          options={question.options}
        />
      );
    case 'number':
      return (
        <NumberFormElement
          id={question.id}
          name={props.name}
          value={props.surveyAnswersState[question.id]}
          text={question.text}
          handleSurveyAnswers={props.handleSurveyAnswers}
          isInGroup={props.isInGroup}
          isSummary={props.isSummary}
          isDependent={props.isDependent}
        />
      );
    case 'dropdown':
      return question.dependency ? (
        <>
          <DropdownFormElement
            id={question.id}
            name={props.name}
            value={props.surveyAnswersState[question.id]}
            text={question.text}
            options={question.options}
            handleSurveyAnswers={props.handleSurveyAnswers}
            isInGroup={true}
            isSummary={props.isSummary}
          />
          {question.dependency.map((e, index) => {
            if (e.dependencyValue === props.surveyAnswersState[question.id]) {
              return (
                <SurveyInputs
                  key={index}
                  question={e}
                  name={props.name}
                  surveyAnswersState={props.surveyAnswersState}
                  handleSurveyAnswers={props.handleSurveyAnswers}
                  isInGroup={true}
                  isSummary={props.isSummary}
                  isDependent={true}
                />
              );
            } else {
              return null;
            }
          })}
        </>
      ) : (
        <DropdownFormElement
          id={question.id}
          dependancySelection={question.dependancySelection}
          surveyAnswersState={props.surveyAnswersState}
          name={props.name}
          value={props.surveyAnswersState[question.id]}
          text={question.text}
          options={question.options}
          handleSurveyAnswers={props.handleSurveyAnswers}
          isInGroup={props.isInGroup}
          isSummary={props.isSummary}
        />
      );
    case 'persona-dropdown':
      return (
        <DropdownAutocomplete
          id={question.id}
          value={props.surveyAnswersState[question.id]}
          surveyAnswers={props.surveyAnswersState}
          text={question.text}
          handleSurveyAnswers={props.handleSurveyAnswers}
          isInGroup={props.isInGroup}
          isSummary={props.isSummary}
          hasTextWrapper={true}
        />
      );
    case 'clients-dropdown':
      return (
        <ClientsDropdownAutocomplete
          id={question.id}
          value={props.surveyAnswersState[question.id]}
          text={question.text}
          handleSurveyAnswers={props.handleSurveyAnswers}
          isInGroup={props.isInGroup}
          isSummary={props.isSummary}
          hasTextWrapper={true}
        />
      );
    case 'info':
      return <InfoFormElement text={question.text} name={props.name} isSummary={props.isSummary} />;
    case 'survey-range-slider':
      return (
        <SurveyRangeSlider
          id={question.id}
          dependancySelection={question.dependancySelection}
          name={props.name}
          text={question.text}
          left={question.left}
          right={question.right}
          value={props.surveyAnswersState}
          handleSurveyAnswers={props.handleSurveyAnswers}
          isInGroup={props.isInGroup}
          isSummary={props.isSummary}
          handleSliderDoubleClick={props.handleSliderDoubleClick}
        />
      );
    case 'survey-range-slider-only-positive':
      return (
        <SurveyRangeSliderOnlyPositive
          id={question.id}
          dependancySelection={question.dependancySelection}
          name={props.name}
          text={question.text}
          left={question.left}
          right={question.right}
          value={props.surveyAnswersState}
          handleSurveyAnswers={props.handleSurveyAnswers}
          isInGroup={props.isInGroup}
          isSummary={props.isSummary}
          handleSliderDoubleClick={props.handleSliderDoubleClick}
        />
      );
    case 'survey-range-slider-left':
      return (
        <SurveyRangeSliderLeft
          id={question.id}
          dependancySelection={question.dependancySelection}
          name={props.name}
          text={question.text}
          options={question.options}
          scale={question.scale}
          isInGroup={props.isInGroup}
          value={props.surveyAnswersState}
          handleSurveyAnswers={props.handleSurveyAnswers}
          isSummary={props.isSummary}
          handleSliderDoubleClick={props.handleSliderDoubleClick}
        />
      );
    case 'survey-positive-range-slider':
      return (
        <SurveyPositiveRangeSlider
          id={question.id}
          name={props.name}
          text={question.text}
          scale={question.scale}
          value={props.surveyAnswersState}
          options={question.options}
          handleSurveyAnswers={props.handleSurveyAnswers}
          isSummary={props.isSummary}
          handleSliderDoubleClick={props.handleSliderDoubleClick}
        />
      );
    case 'wrapper':
      return (
        <Wrapper
          heading={question.heading}
          subHeading={question.subHeading}
          fields={question.fields}
          surveyAnswersState={props.surveyAnswersState}
          handleSurveyAnswers={props.handleSurveyAnswers}
          isSummary={false}
        />
      );
    case 'group':
      return (
        <>
          {question.fields.map((e, index) => {
            return (
              <SurveyInputs
                key={index}
                question={e}
                name={props.name}
                surveyAnswersState={props.surveyAnswersState}
                handleSurveyAnswers={props.handleSurveyAnswers}
                isInGroup={true}
                isSummary={props.isSummary}
                handleSliderDoubleClick={props.handleSliderDoubleClick}
              />
            );
          })}
        </>
      );
    case 'survey-summary':
      return (
        <SurveySummary
          questions={question}
          surveyAnswersState={props.surveyAnswersState}
          handleSurveyAnswers={props.handleSurveyAnswers}
          handleSliderDoubleClick={props.handleSliderDoubleClick}
        />
      );
    default:
      return null;
  }
};

export default SurveyInputs;
